export function readJsonArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [];
}
